// eslint-disable-next-line no-restricted-imports
import type { FilesizeOptions } from "filesize";
// eslint-disable-next-line no-restricted-imports
import { filesize as filesizeFunction } from "filesize";

export function filesize(bytes: number | undefined | null, fallback: string = "-", options?: FilesizeOptions) {
    if (!bytes) {
        return fallback;
    }
    const result = filesizeFunction(bytes, { standard: "jedec", ...options });
    return result;
}
